import React, { useState, useEffect, } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';
import { Api } from '../../../services/api';

const CostPerSf = () => {
  const [projects, setProjects] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
 
  
  useEffect(() => {
    getDashboardData();
  }, []);

 
  const getDashboardData = () => {
    setIsLoading(true);
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
    };
    axios.get(Api.API_BASE_URL + 'pre-con/cc-per-rf',{headers})
      .then((response) => {
        setProjects(response.data.result)
        setIsLoading(false);
       
        var dea = [];

        response.data.result.forEach(element => {
          const isNameExist = dea.some(item => item.category === element.category);
          if (isNameExist) {
            // console.log('exist');
          } else {
            dea.push(element);
          }
        })
        setExpandedRows(dea);
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });
  }

  const headerTemplate = (data) => {
    var t = data.category

    return (
      <React.Fragment>
        <th colSpan="1" className="no-horizontal-scroll p-frozen-column myheader" style={{ border: 'none' }}>
                   
           <span style={{ overflowX: "hidden", whiteSpace: "nowrap" }}>
            <i className="" ></i> {t}
          </span>
        </th>
      </React.Fragment>
    );
  };


  const balanceTemplate = (rowData, field) => {
    // let value = rowData.costPerSFAmount;
    let value = rowData[field];
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }
    if (isNaN(value) || value === 0) {
      return '';
    }
    return <span className="font-bold">{formatCurrency(value)}</span>;
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };  const balanceTemplateYY = (rowData) => {
    // let value = rowData.costPerSFAmount;
    let value = rowData
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }
    if (isNaN(value) || value === 0) {
      return '';
    }
    return <span className="font-bold">{formatCurrency(value)}</span>;
  };

  

 
  const header = (
    <div className="flex  justify-content-between gap-8">
     
    </div>
  );

  const rowClass = (data) => {
    return {
      'bg-gray-200': data.pM === 'Total Jobs' || data.pM === 'PM Available' || data.pM === 'PM Capacity' || data.pM === 'PM +/-'
    };
  };

  const CostPerSFAmount = (totalSqFt,contractAmount) => {
    if(totalSqFt === '' || totalSqFt === null || totalSqFt === undefined || totalSqFt === 'NaN' || totalSqFt === 0 ){
        return '';

    }


    const value = contractAmount / totalSqFt;
    const costPerSFAmount = (value === null || value === undefined || value.toString() === 'NaN' || value === '' || value === Infinity) ? 0 : value;

    console.log('costPerSFAmount', costPerSFAmount);
    
    return (
        <span>{balanceTemplateYY(costPerSFAmount)}</span>
    );
};

  return (
    <>

      <div className="card" style={{ paddingTop: '0', overflow: 'hidden' }}>
        <div className="fd" >
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <div>
              <div className="dataTableContainer pt-2">
                <DataTable
                  value={projects}
                  rowClassName={rowClass}
                  rowGroupMode="subheader"
                  groupRowsBy="category"
                  size="small"
                  showGridlines
                  sortMode="single"
                  sortField="category"
                  sortOrder={1}
                  scrollable
                  scrollHeight="flex"
                  expandableRowGroups={true}
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  rowGroupHeaderTemplate={headerTemplate}
                  
                  header={header}
                  className='p-frozen-column'
                  tableStyle={{ minWidth: '100px', tableLayout: 'fixed', width: 'auto', borderCollapse: 'separate', borderSpacing: '0', }}
                >

                  <Column field="costPerSF" header="SUB CATEGORY"  style={{ minWidth: '300px', textAlign: 'left', marginLeft: '2px', }} />

                  <Column field="project_name" header="PROJECT"  style={{ minWidth: '400px', textAlign: 'center', }} />

                 

                  <Column field="totalSqFt" header="Total Sq Ft"   style={{ minWidth: '200px', textAlign: 'center', marginLeft: '2px' }} />

                  <Column field="contract_amount" header="contract amount" body={(rowData) => balanceTemplate(rowData, 'contract_amount')}   style={{ minWidth: '200px', textAlign: 'center', marginLeft: '2px' }} />

                  <Column field="costPerSFAmount" header="COST PER SF" body={(rowData) => CostPerSFAmount(rowData.totalSqFt, rowData.contract_amount, )}  style={{ minWidth: '200px', textAlign: 'center', marginLeft: '2px' }} />
                  

                  <Column field="costPerSFComments" header="NOTES"  style={{ minWidth: '300px', textAlign: 'left', marginLeft: '2px', }} />

                </DataTable>
              </div>
            </div>
          )}
{/* --------------Modal Open--------------- */}
        </div>
       
      </div>
    </>
  )
}

export default CostPerSf